import {
  GlobalCharacteristicRowTypes,
  GlobalReferenceProperties,
  GlobalReferenceFunctions,
  LibraryCharacteristicRowTypes,
  LibraryReferenceFunctions,
  LibraryReferenceProperties,
  DatatypeCharacteristicRowTypes,
  DatatypeReferenceProperties,
  DatatypeReferenceMethods,
  DatatypeReferenceFunctions,
  DatatypeReferenceConstructors,
  DatatypeReferenceMathOperations,
  CharacteristicsRowTypes,
  APIReferenceProperties,
  APIReferenceMethods,
  APIReferenceEvents,
  APIReferenceCallbacks,
} from '../types';

export const isProperty = (row: CharacteristicsRowTypes): row is APIReferenceProperties => {
  // eslint-disable-next-line no-underscore-dangle
  return row.__typename === 'ClassProperty';
};

export const isMethod = (row: CharacteristicsRowTypes): row is APIReferenceMethods => {
  // eslint-disable-next-line no-underscore-dangle
  return row.__typename === 'Method';
};

export const isEvent = (row: CharacteristicsRowTypes): row is APIReferenceEvents => {
  // eslint-disable-next-line no-underscore-dangle
  return row.__typename === 'Event';
};

export const isCallback = (row: CharacteristicsRowTypes): row is APIReferenceCallbacks => {
  // eslint-disable-next-line no-underscore-dangle
  return row.__typename === 'Callback';
};

export const isGlobalProperty = (
  row: GlobalCharacteristicRowTypes,
): row is GlobalReferenceProperties => {
  // eslint-disable-next-line no-underscore-dangle
  return row.__typename === 'Property';
};

export const isGlobalFunction = (
  row: GlobalCharacteristicRowTypes,
): row is GlobalReferenceFunctions => {
  // eslint-disable-next-line no-underscore-dangle
  return row.__typename === 'Function';
};

export const isLibraryProperty = (
  row: LibraryCharacteristicRowTypes,
): row is LibraryReferenceProperties => {
  // eslint-disable-next-line no-underscore-dangle
  return row.__typename === 'Property';
};

export const isLibraryFunction = (
  row: LibraryCharacteristicRowTypes,
): row is LibraryReferenceFunctions => {
  // eslint-disable-next-line no-underscore-dangle
  return row.__typename === 'Function';
};

export const isDatatypeProperty = (
  row: DatatypeCharacteristicRowTypes,
): row is DatatypeReferenceProperties => {
  // eslint-disable-next-line no-underscore-dangle
  return row.__typename === 'DatatypeProperty';
};

export const isDatatypeFunction = (
  row: DatatypeCharacteristicRowTypes,
): row is DatatypeReferenceFunctions => {
  // eslint-disable-next-line no-underscore-dangle
  return row.__typename === 'DatatypeFunction';
};

export const isDatatypeMethod = (
  row: DatatypeCharacteristicRowTypes,
): row is DatatypeReferenceMethods => {
  // eslint-disable-next-line no-underscore-dangle
  return row.__typename === 'DatatypeMethod';
};

export const isDatatypeConstructor = (
  row: DatatypeCharacteristicRowTypes,
): row is DatatypeReferenceConstructors => {
  // eslint-disable-next-line no-underscore-dangle
  return row.__typename === 'Constructor';
};

export const isDatatypeMathOperation = (
  row: DatatypeCharacteristicRowTypes,
): row is DatatypeReferenceMathOperations => {
  // eslint-disable-next-line no-underscore-dangle
  return row.__typename === 'MathOperation';
};

export const getParams = (row: CharacteristicsRowTypes) => {
  if (!isProperty(row)) {
    return row.parameters ?? [];
  }
  return undefined;
};

export const getGlobalOrLibraryParams = (
  row: GlobalCharacteristicRowTypes | LibraryCharacteristicRowTypes,
) => {
  if (isGlobalFunction(row) || isLibraryFunction(row)) {
    return row.parameters ?? [];
  }
  return undefined;
};

export const getDatatypeParams = (row: DatatypeCharacteristicRowTypes) => {
  if (isDatatypeFunction(row) || isDatatypeMethod(row) || isDatatypeConstructor(row)) {
    return row.parameters ?? [];
  }
  return undefined;
};

export const getCharacteristicKey = (name: string, paramsList: { name: string }[] | undefined) => {
  const paramsKey = paramsList?.map((param) => param.name).join('-');
  return `${name}-${paramsKey}`;
};

export const getClassRowName = (row: CharacteristicsRowTypes) => {
  return isMethod(row)
    ? row.name.substring(row.name.indexOf(':') + 1)
    : row.name.substring(row.name.indexOf('.') + 1);
};
